var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProperty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 33C1 15.3269 15.3269 1 33 1V1C50.6731 1 65 15.3269 65 33V33C65 50.6731 50.6731 65 33 65V65C15.3269 65 1 50.6731 1 33V33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 19H16V60H31V19Z",
    fill: "#828C9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19H31L23.4989 10L16 19Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 55H15V60H17V55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M20.5 22H18.5V49H20.5V22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M24.5 22H22.5V49H24.5V22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M28.5 22H26.5V53H28.5V22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 49.9249C9.01269 47.2278 5.77637 45.984 4.0449 47.9889C2.5342 49.6944 1.57121 51.8477 1.28982 54.1495C0.59978 60.0715 1.35857 73 1.35857 73H3.41597C3.41597 73 4.80624 60.0794 7.8414 54.1495C8.68677 52.4973 8.99487 51.0918 8.99996 49.9249Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.276 40.6904C13.6049 41.4499 13.8461 42.2588 13.9931 43.0952C14.0055 43.1956 14.0011 43.2979 13.9802 43.3962C13.9592 43.4945 13.922 43.5869 13.8708 43.668C13.8196 43.7491 13.7554 43.8173 13.6819 43.8686C13.6084 43.9199 13.5271 43.9534 13.4427 43.967C13.1728 44.0311 12.8931 44.0014 12.6371 43.8815C12.381 43.7616 12.1593 43.5565 11.9984 43.2906L11.2132 42.2205C11.0745 41.9877 11 41.7093 11 41.4239C11 41.1385 11.0745 40.8601 11.2132 40.6273C11.6879 39.7255 12.9503 39.8397 13.276 40.6904Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2405 42L11 46L14 45.9401L12.9697 43.0539L11.2405 42Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6 41.5L14.446 41.8405C14.4932 41.8604 14.5321 41.8878 14.559 41.9201C14.5859 41.9524 14.6 41.9886 14.6 42.0255C14.6 42.0623 14.5859 42.0985 14.559 42.1309C14.5321 42.1632 14.4932 42.1906 14.446 42.2105L13.7676 42.5L13.6 41.5Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M13.524 43.2535C12.9598 43.2258 12.4299 43.1376 12 43C12 43 12.2308 43.5319 14 44L13.524 43.2535Z",
    fill: "#CE8172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4816 43L10.5691 41.237C10.5691 41.237 9.72548 40.9471 10.0925 40.1845C10.4595 39.4218 11.0075 39.7669 11.2165 38.7752C11.2336 38.5972 11.2987 38.4295 11.4027 38.295C11.5068 38.1606 11.6447 38.066 11.7978 38.0241C11.9509 37.9822 12.1116 37.9951 12.258 38.0611C12.4044 38.127 12.5293 38.2427 12.6158 38.3925C12.9242 38.9057 14.0201 38.3519 13.9997 39.2624C13.9793 40.1729 12.9573 40.544 12.6667 40.6484C11.3949 41.1007 12.9828 42.6839 11.4816 43Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M9.46858 48C9.46858 48 12.2442 49.9447 11.3711 55.9251C11.1159 57.6734 11.2192 59.4615 11.6737 61.1611C12.1283 62.8607 12.9227 64.4295 14 65.7549L10.1875 66C10.1875 66 7.74209 60.4511 7.09159 59.2736C6.4411 58.0962 9.46858 48 9.46858 48Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M8.99996 49.9249C9.01269 47.2278 5.77637 45.984 4.0449 47.9889C2.5342 49.6944 1.57121 51.8477 1.28982 54.1495C0.59978 60.0715 1.35857 73 1.35857 73H3.41597C3.41597 73 4.80624 60.0794 7.8414 54.1495C8.68677 52.4973 8.99487 51.0918 8.99996 49.9249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M49.975 21H43V50.2378H49.9029V55.9024H58.5194V42.3082H49.975V21Z",
    fill: "#DDDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M62.7128 27.7381H52.1477V50.1788H62.7128V27.7381Z",
    fill: "#DDDBDB"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66 48H45V60H66V48Z",
    fill: "#A7B1C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1166 60H-7.11662C-7.6045 60 -8 61.3431 -8 63C-8 64.6569 -7.6045 66 -7.11662 66H61.1166C61.6045 66 62 64.6569 62 63C62 61.3431 61.6045 60 61.1166 60Z",
    fill: "#335C75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 54H48V60H50V54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 52H56V57H63V52Z",
    fill: "#335C75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 27H32V30H37V27Z",
    fill: "#335C75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 46H51V48H57V46Z",
    fill: "#335C75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 30H31V60H45V30Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M41 48H39V52H41V48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M36 48H34V52H36V48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M45 30H31V34H45V30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 54H34V60H41V54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M41 36H39V40H41V36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M36 36H34V40H36V36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M41 42H39V46H41V42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M36 42H34V46H36V42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0441 46.5224C16.9868 46.3185 16.9853 46.1034 17.0397 45.8988C17.094 45.6941 17.2022 45.5072 17.3535 45.3568C17.5048 45.2065 17.6937 45.098 17.9012 45.0424C18.1087 44.9867 18.3275 44.9859 18.5354 45.0399C22.4278 46.086 25.8473 48.3934 28.2399 51.5885C28.6656 52.1565 29.0724 52.7111 29.4547 53.247C30.7262 55.0265 31.2424 57.2234 30.8936 59.371C30.5448 61.5187 29.3584 63.4482 27.5865 64.7497L23.1694 68L21.4232 66.4295L24.9671 63.0992C25.4214 62.6722 25.7827 62.1589 26.029 61.5904C26.2753 61.0219 26.4016 60.4101 26.4 59.7922C26.3985 59.1742 26.2693 58.563 26.0202 57.9957C25.771 57.4284 25.4072 56.9168 24.9509 56.492L17.9931 50.0207L17.0441 46.5224Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M17.0441 46.5224C16.9868 46.3185 16.9853 46.1034 17.0397 45.8988C17.094 45.6941 17.2022 45.5072 17.3535 45.3568C17.5048 45.2065 17.6937 45.098 17.9012 45.0424C18.1087 44.9867 18.3275 44.9859 18.5354 45.0399C22.4278 46.086 25.8473 48.3934 28.2399 51.5885C28.6656 52.1565 29.0724 52.7111 29.4547 53.247C30.7262 55.0265 31.2424 57.2234 30.8936 59.371C30.5448 61.5187 29.3584 63.4482 27.5865 64.7497L23.1694 68L21.4232 66.4295L24.9671 63.0992C25.4214 62.6722 25.7827 62.1589 26.029 61.5904C26.2753 61.0219 26.4016 60.4101 26.4 59.7922C26.3985 59.1742 26.2693 58.563 26.0202 57.9957C25.771 57.4284 25.4072 56.9168 24.9509 56.492L17.9931 50.0207L17.0441 46.5224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.86 44.0013C13.7221 44.078 9.63782 44.9529 5.83088 46.578C5.24722 46.8254 4.72039 47.1899 4.28286 47.6489C3.84534 48.108 3.5064 48.652 3.28697 49.2472C3.06753 49.8425 2.97224 50.4764 3.00697 51.11C3.04171 51.7435 3.20573 52.3632 3.48893 52.9308L10.0399 66L22.1754 65.2814C22.1754 65.2814 24.3837 57.9366 23.9415 49.6274C23.8521 48.0841 23.1685 46.6356 22.0344 45.5864C20.9002 44.5372 19.4039 43.969 17.86 44.0013V44.0013Z",
    fill: "#00A0F3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 64C15.8792 64 2 50.1208 2 33H0C0 51.2254 14.7746 66 33 66V64ZM64 33C64 50.1208 50.1208 64 33 64V66C51.2254 66 66 51.2254 66 33H64ZM33 2C50.1208 2 64 15.8792 64 33H66C66 14.7746 51.2254 0 33 0V2ZM33 0C14.7746 0 0 14.7746 0 33H2C2 15.8792 15.8792 2 33 2V0Z",
    fill: "#E6EBEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_419"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 33C1 15.3269 15.3269 1 33 1V1C50.6731 1 65 15.3269 65 33V33C65 50.6731 50.6731 65 33 65V65C15.3269 65 1 50.6731 1 33V33Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/Property.387e351f16a5e145cb3275a20f3eeefe.svg";
export { ForwardRef as ReactComponent };